import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaGraduationCap } from 'react-icons/fa';

const NeetBanner = ({ shown, onDismiss }) => (
  <AnimatePresence>
    {shown && (
      <motion.div
        key="neet-banner"
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 40, opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
        className="fixed top-0 left-0 right-0 z-[60] overflow-hidden bg-primary-800"
      >
        <div className="h-10 flex items-center justify-center gap-3 px-4 text-white text-sm font-medium">
          <FaGraduationCap className="shrink-0 text-primary-200 text-xs" aria-hidden />
          <span className="hidden sm:inline">
            <span className="font-semibold">New:</span> Free NEET College Predictor — see which medical colleges match your rank
          </span>
          <span className="sm:hidden text-xs">
            Free NEET College Predictor
          </span>
          <a
            href="#neet-predictor"
            onClick={onDismiss}
            className="shrink-0 px-3 py-1 rounded-full bg-white text-primary-800 text-xs font-semibold hover:bg-primary-50 transition-colors duration-150"
          >
            Try it now →
          </a>
          <button
            onClick={onDismiss}
            aria-label="Dismiss banner"
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded hover:bg-primary-700 transition-colors duration-150"
          >
            <FaTimes className="text-xs" />
          </button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default NeetBanner;
